<template>
  <div
    class="price-card"
    :class="{ '_current_plan' : entries.isCurrent }"
    >

    <div class="price-header">
      <div class="name">
        <span>{{ entries.title }}</span>
        <div v-if="entries.recommended" class="pop-tag">Popular</div>
      </div>
      <template v-if="planTerm === 'short'">
        <div class="price">
            <span v-if="getPrice(entries.priceShortTerm,entries.name)>0">$</span>{{ getPrice(entries.priceShortTerm,entries.name)}}
          <span class="per-month">{{ entries.shortTerm }}</span>
        </div>
      </template>
      <template v-else-if="planTerm === 'year'">
        <div class="price">
          {{ getPrice(entries.price,entries.name) }}
          <span  class="per-month">{{ entries.shortTerm  }}</span>
        </div>
      </template>
    </div>

    <hr class="separator" :style="{ 'border-color': `${entries.recommended ? 'var(--color-success)' : 'rgb(230,230,230)' } !important` }">
  
       <div class="price-features">
        <div class="section">Key Offerings</div> 
 
          <div v-for="e in entries.offers" :key="e" class="feature">
              <SVGIcon
                :iconName="'check_circle'"
                :width="'18px'"
                :height="'18px'"
                class="icon"
                :style="{color: `${entries.bkColor ? entries.bkColor : 'var(--color-success)'}` }"
              />
              <div class="key">{{ e.k }}</div>
              <span class="value">{{ e.v }}</span>
      </div>

    </div>

    <div class="price-features">
     <div class="section">Capabilities and Features</div> 

      <div v-for="e in entries.features" :key="e" class="feature">
        <SVGIcon
          :iconName="'check_circle'"
          :width="'18px'"
          :height="'18px'"
          class="icon"
          :style="{color: `${entries.bkColor ? entries.bkColor : 'var(--color-success)'}` }"
        />
        <span>{{ e }}</span>
      </div>
    </div>


    <div class="footer">
      <button
        class="button signup"
        :disabled="entries.isDisabled"
        @click="selectPlan(entries.name,entries.shortTerm,entries.title)"
      >
        <!-- {{ entries.buttonText }} -->
          Select
      </button>
    </div>
  </div>
</template>

<script>
import SVGIcon from '@/components/SVGIcon.vue';

export default {

  components: {
    SVGIcon,
  },
  props: {
    planTerm: {
      type: String,
      default: "month",
    },
    currentPlanTerm: {
      type: String,
      default: "",
    },
    entries: {
      type: Object,
      default: () => {},
    },
    isLanding: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['plan_clicked', 'to-contact-us'],
  methods: {
    getPrice(p,name) {
      if  (name.includes("free")) return "Free";
      if  (name.includes("custom")) return "Call us";
      return p;

    },  

    selectPlan(plan_name,term,title) {
      if (term.startsWith("/")) {
        term = term.slice(1);
      }
      if (this.planTerm=="year") term="year";
      const d={name:plan_name,term:term,title:title};
      this.$emit('plan_clicked', d);
    },
    toSignupPage() {
      this.$router.push({ path: '/signup' });
    },
    toLoginPage() {
      this.$router.push({ path: '/login' });
    },
    toContactUs() {
      this.$emit('to-contact-us');
    },
  },
};
</script>

<style lang="scss" scoped>

.price-card {
  font-size: .8em;
  font-weight: 600;
  width: 360px;
  height: 650px;
  box-shadow: 3px 3px 12px rgba(0, 0, 0, 0.2);
  padding: 20px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 2px solid rgb(220, 217, 217);

  &._current_plan {
    //background-color: tint-color($color-success, 85%) !important;
    border: 2px solid var(--color-success);
  }
}

@media (max-width: 1200px) {
  .price-card {
    width: 100%;
  }
}

.name {
  display: flex;
  flex-direction: row;
  font-size: 1.9rem;
  padding: 1px;
  font-weight: 600;
  color: rgb(55, 65, 90);

  .pop-tag{
    border: 1px solid var(--color-success);
    color: var(--color-success);
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    width: fit-content;
    height: fit-content;
    padding: 1px;
    margin-left: 5px;
  }
}

.price {
  font-size: 2rem;
  font-weight: 400;
  padding: 1px;
  color: rgb(94, 87, 54);
  ;
}

.price-header{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
}
.price-features {
  margin:5px 0;
  font-size: 1em;
  flex: 1;

  .feature {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }

  .feature + .feature {
    margin-top: 5px;
  }
}

.signup {
  border-radius: 6px;
  text-align: center;
}

.footer {
  padding: 10px;
  display: flex;
  margin: auto;
}

.per-month {
  font-size: 1rem;
  line-height: 1.375rem;
  margin-left: 1px;
}

.annual-plan{
  font-size: 0.7rem;
}

.separator {
  border-color: rgb(230,230,230);
}

.section {
  text-align: left;
  font-weight: 400;
  font-size: 1.4em;
  margin-bottom: 6px;
  font-style: italic;
  color: rgb(120, 126, 13);
}

.key {
  font-weight: 600;
  width: 180px;
  text-align: left;
}
.value {
  font-weight: 100;
  font-style: italic;
}
</style>
